import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { Section, Reveal, Eyebrow, CTAButton, TrustBadges } from "./ui";
const faqs = [{
  q: "¿Cómo recibo el material?",
  a: "Inmediatamente después de la compra recibís un acceso para descargar todos los tomos y bonos. No hay que esperar envíos ni tiempos: lo tenés disponible al instante."
}, {
  q: "¿Es digital?",
  a: "Sí. Es 100% digital, en formato PDF. Lo podés leer, buscar y consultar cuando lo necesites desde cualquier dispositivo."
}, {
  q: "¿Sirve para cualquier edad?",
  a: "Las estrategias están pensadas para acompañar la infancia, y muchas se adaptan a distintas etapas del desarrollo. Vas a poder aplicar lo que corresponda a cada momento de tu hijo."
}, {
  q: "¿Necesito conocimientos previos?",
  a: "No. Todo está explicado de forma clara, práctica y fácil de aplicar, sin tecnicismos. Está pensado para familias, no para especialistas."
}, {
  q: "¿Tiene pagos mensuales?",
  a: "No. Es un pago único. No hay suscripciones ni cargos recurrentes: accedés una vez y es tuyo para siempre."
}, {
  q: "¿Los bonos están incluidos?",
  a: "Sí. Los 3 bonos están incluidos sin costo adicional dentro del acceso al sistema completo."
}, {
  q: "¿Qué pasa si no me gusta?",
  a: "Tenés 7 días de garantía. Si sentís que no era lo que esperabas, te devolvemos el dinero sin complicaciones."
}];
function Item({
  q,
  a,
  open,
  onClick
}: {
  q: string;
  a: string;
  open: boolean;
  onClick: () => void;
}) {
  return <div className="overflow-hidden rounded-2xl border border-[#e6eef5] bg-white" data-id="element-59" data-mp="s047bnli1950">
      <button onClick={onClick} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left sm:px-6" aria-expanded={open} data-id="element-60" data-mp="wxcpho6ndd69">
        <span className="text-sm font-semibold text-[var(--ink)] sm:text-base" data-id="element-61" data-mp="mzyhmcyshwpk">{q}</span>
        <motion.span animate={{
        rotate: open ? 45 : 0
      }} transition={{
        duration: 0.2
      }} className="flex h-8 w-8 flex-none items-center justify-center rounded-full bg-[var(--calm-blue)] text-[var(--accent)]" data-id="element-62" data-mp="n1stz2vzwgi1">
          <PlusIcon className="h-4 w-4" aria-hidden data-id="element-63" data-mp="2fxvflw6wdpsx" />
        </motion.span>
      </button>
      <AnimatePresence initial={false} data-id="element-64" data-mp="2ayikko5vhcf9">
        {open && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: "auto",
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-65" data-mp="2avwe6rupx2ym">
            <p className="px-5 pb-5 text-sm leading-relaxed text-[var(--muted)] sm:px-6" data-id="element-66" data-mp="2ym0eoqcm0mle">
              {a}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <Section id="faq" className="bg-white" data-id="element-67" data-mp="1j6bc4b0it6by">
      <Reveal className="text-center" data-id="element-68" data-mp="1j8nton2d9eoh">
        <Eyebrow data-id="element-69" data-mp="3uug7rwtk6xo4">Preguntas frecuentes</Eyebrow>
        <h2 className="font-serif-display text-3xl font-semibold leading-tight text-[var(--ink)] sm:text-4xl" data-id="element-70" data-mp="3uvrbxxqx27fr">
          Todo lo que necesitás saber antes de empezar.
        </h2>
      </Reveal>

      <div className="mx-auto mt-6 max-w-2xl space-y-2.5 sm:mt-10 sm:space-y-3" data-id="element-71" data-mp="7nnoinl2prve">
        {faqs.map((f, i) => <Reveal key={f.q} delay={i * 0.04} data-id="element-72" data-mp="ci07kwin116m" data-mpi={i}>
            <Item q={f.q} a={f.a} open={open === i} onClick={() => setOpen(open === i ? null : i)} data-id="element-73" data-mp="hfjok46pzs29" />
          </Reveal>)}
      </div>

      <Reveal delay={0.1} className="mt-8 text-center sm:mt-12" data-id="element-74" data-mp="qfgc22hdikvq">
        <CTAButton data-id="element-75" data-mp="vesywn88vryb">Quiero empezar hoy</CTAButton>
        <TrustBadges className="mt-5" compact data-id="element-76" data-mp="vdi071tnpae2" />
      </Reveal>
    </Section>;
}